import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledAnchor = styled.span`
  display: block;
  scroll-margin-top: var(--header-height, 0px);
  visibility: hidden;
`;

export default function Anchor(props) {
  const { id } = props;
  return <StyledAnchor id={id} />;
}

Anchor.propTypes = {
  id: PropTypes.string,
};



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/main/utils/Anchor.js